var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LMarker',{attrs:{"lat-lng":[_vm.lat, _vm.lng],"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }